function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 40,
  fill: "#E5E5D6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M50 40H70",
  stroke: "#4E603F",
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M63 33L70 40L63 47",
  stroke: "#4E603F",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30 40L10 40",
  stroke: "#4E603F",
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17 47L10 40L17 33",
  stroke: "#4E603F",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

function SvgIconDrag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref2), _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrag);
export default __webpack_public_path__ + "static/media/icon-drag.87cb39ec.svg";
export { ForwardRef as ReactComponent };